import { RegenData } from "../../components/PayoutManagement/helper/payoutdatasample";

const initialState = {
    payoutMissingMonthForGenReport: [],
    payoutMissingMonthForReGenReport: [],
    loading: false,
    error: null,
};

 const payoutMissingMonthforGenReportReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'PAYOUT_MISSING_MONTH_FOR_GEN_REPORT_SUCCESS':
            return {
                ...state,
                payoutMissingMonthForGenReport: action.payload.months_missing,
            payoutMissingMonthForReGenReport: action.payload.months_missing_reGen,
                loading: false,
                error: null,
            };
        case 'PAYOUT_MISSING_MONTH_FOR_GEN_REPORT_ERROR':
            return {
                ...state,
                loading: false,
                error: action.payload,
            };
        default:
            return state;
    }
};

export default payoutMissingMonthforGenReportReducer;